import React, { Component } from "react";
import PropTypes from "prop-types";

// this is used within the Date Picker component;
// as the trigger to open the Date Picker;

// even though this doesn't make use of state, it shouldn't be a stateless component;
// if it's stateless, a React error will be thrown in the console about adding a ref to a stateless component;
// the ref is added by the Date Picker;

export default class ScheduleByTimeslotJump extends Component {
  render() {
    return (
      <button className="btn btn-default" onClick={this.props.onClick}>
        <i className="fa fa-calendar" aria-hidden="true"></i>
        Jump to Date
      </button>
    );
  }
}

ScheduleByTimeslotJump.propTypes = {
  onClick: PropTypes.func // trigger the Date Picker;
};
